import { useUpgradePopupContextSelector } from "@/features/Payments/PaywallPopup/UpgradePopupContext";
import { UpgradeEvent } from "@knowt/syncing/graphql/schema";
import useWelcomeOffer from "@knowt/syncing/hooks/subscriptions/utils/useWelcomeOffer";

const WelcomeOffer = () => {
    const openUpgradePopup = useUpgradePopupContextSelector(state => state.openUpgradePopup);

    useWelcomeOffer({
        onShowOffer: (offerNumber: number) => {
            openUpgradePopup({
                event: UpgradeEvent.MAX_PDF_AI,
                isForPromotion: true,
                offerNumber,
                context: {},
            });
        },
    });

    return null;
};

export default WelcomeOffer;
